import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup"
import { FormError } from "../../components/FormError";
import { allActiveRoles } from "../../slices/PermissionsSlice";
import { useDispatch, useSelector } from "react-redux";
import { MessageModel } from "../../components/MessageModel"
import * as Yup from "yup"
import {useNavigate, useParams } from "react-router-dom"
import React, { useEffect, useState } from "react";
import SelectBox from "../../components/admin/SelectBox";
import  defaultConfig  from "../../config/Config"
import { CityByState, getAllState } from "../../slices/InitialDataSlice";
import { resetApiStatus, saveUser, getUserById, getParentUsers } from "../../slices/UserSlice";
import defaultImg from "../../assets/images/SD-default-image.png"
import { Loading } from "../../components/Loading";
import { imageValidation } from "../../Utils/utils";
import { imageTypeList } from "./const";
import { loadDepartments } from "../../slices/DepartmentsSlice";
import ModelBox from "../../common/ModelBox";
import { ReplaceUser } from "../../components/admin/user/ReplaceUser";

export function AddUser(){
  const dispatch = useDispatch();
  const navigate = useNavigate ();
  const vErrors = useSelector((state)=> state.users.errors)
  const success = useSelector((state)=> state.users.success)
  const editData = useSelector( (state) => state.users.editData )
  const roleData = useSelector((state)=> state.permissions.roleList)
  const loading = useSelector((state)=> state.users.loading)
  const initialData = useSelector( (state) => state.initialData )
  const departments = useSelector( (state)=> state.departments?.list )
  const parentUserList = useSelector( (state)=> state.users.parentUser )
  const teamList = useSelector( (states) => states.users.replacmentTeamLsit)
  const [roleList, setRoleList] = useState([])
  const [cities, setCities] = useState([])
  const [states, setStates] = useState([])
  const [userData, setUserData] = useState({})
  const [files, setFiles] = useState({})
  const [imagePath, setImagePath] = useState(defaultImg)
  const [imageSchema, setImageSchema] = useState({})
  const [pinCodeList, setPinCodeList] = useState([])
  const [departmentsList, setDepartmentsList] = useState([])
  const [reportingTo, setReportingTo] = useState([])
  const [showStatusPopup, setShowStatusPopup] = useState(false);
  const [popUpContent, setPopUpContent] = useState();
  const [replacementList, setReplacementList] = useState([]);
  const params = useParams()
  const formSchema = Yup.object().shape({
    empCode: Yup.string().required("Please employe code"),
    name: Yup.string().required("Please enter full name"),
    email: Yup.string()
      .email("Please enter vaild email")
      .required("Please enter email"),
    address: Yup.string()
      .required("Please enter address"),
    city: Yup.string()
        .required("Please select city"),
    state: Yup.string()
        .required("Please select state"),
    gender: Yup.string()
        .required("Please select gender"),
    role: Yup.string()
        .required("Please select role"),  
    phone: Yup.string()
      .required("Please enter mobile number")
      .matches(
        /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
        "Please enter valid mobile number"
      ),
    pincode: Yup.string()
      .required("Please select pincode"),
    password: Yup.string()
      .transform(x => x === '' ? undefined : x)
      .concat(!userData ? Yup.string().required('Password is required') : null)
      .min(6, "Password length should be at least 6 characters"),
    confPass: Yup.string()
      .when('password', (password, schema) => {
        if (password && !userData) return schema.required('Confirm Password is required');
      })
      .oneOf([Yup.ref("password")], "Passwords must and should match"),
    // replaceById: Yup.string().nullable()
    //               .when('status', (status, schema) => {
    //                 if (status === "inactive") return schema.required("Please select replacement.");
    //               }),
    ...imageSchema
  });
  const [imagesType] = useState(imageTypeList)
  const { 
    control,
    register, 
    handleSubmit, 
    setValue,
    getValues,
    reset,
    formState: { errors } 
  } = useForm({
    mode:"onBlur",
    resolver: yupResolver(formSchema)
  });

  useEffect( () => {
    setReplacementList(teamList)
  }, [teamList])

  useEffect( () => {
    setUserData(editData);
  }, [editData])

  useEffect(() => {
      dispatch(resetApiStatus())
  }, [dispatch])

  useEffect( ()=>{
    if(typeof params.id !== "undefined"){
      dispatch(getUserById(params.id))
    }
    dispatch(allActiveRoles())
    dispatch(getAllState())
  }, [dispatch, params.id])

  useEffect( () => {
    dispatch(loadDepartments())
  }, [dispatch])

  useEffect( () => {
    if(departments){
      const list = departments.map( ( item ) => {
        return {
          value: item._id,
          label: item.label,
        }
      })
      setDepartmentsList(list)
    }
  }, [departments])

  useEffect( () => {
    let roleList = roleData?.map( (item) => {
          return {
              value:item._id,
              label:item.label
          }
    })

    if(roleList){
      setRoleList(roleList)
    }

    if(initialData.StateList !== states){
      let stateList = []
        initialData?.StateList?.forEach(item => {
                    if(item._id !== ""){
                      stateList.push({
                        value : item._id,
                        label: item.name
                      })
                    }
        })
        setStates(stateList)
    }

    if(initialData.CitiesList !== cities){
      let citiesList = []
      initialData.CitiesList.forEach(item => {
                  if(item._id !== ""){
                    citiesList.push({
                      value : item._id,
                      label: item.name
                    })
                  }
      })
      setCities(citiesList)
      setPinCodeList(getPinCodes(userData?.city))
    }  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[roleData, initialData.StateList, initialData.CitiesList, userData])

  useEffect( () =>{
    
    setImageSchema(imageValidation(
      {
        imagesType,
        Yup,
        user:userData
      }
    ))

    for( let key in userData ){
      setValue(key, userData[key])
    }

    if(userData?.state){
      dispatch(CityByState(userData.state)).then(()=>{
        setValue('pincode', userData.pincode)
        setValue('city', userData.city)    
      })  
    }

    if(userData?.reportingTo){
      const { role: roleId, departments: departmentId, _id} = getValues()
      if(departmentId && roleId )
        dispatch(getParentUsers({ roleId, departmentId, currentUserId: _id }) )
    }
    let image = defaultImg
    if(userData?.image){
      image = `${defaultConfig.localDocFilePath}/assets/${userData?._id}/${userData?.image}`
    }
    setImagePath(image)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[userData])

  useEffect( () => {
    if(parentUserList){
      const list = parentUserList.map((userData) => {
          return {
            label: userData.name,
            value: userData._id
          }
      })
      setReportingTo(list)
    }
  }, [parentUserList])

  const onSubmit = function(data){
    delete data.image
    data.files = files
    if(typeof params.id !== "undefined"){
      data.id = params.id
    }
    dispatch(saveUser(data))
  };

  const onStateChange = (callback, opt)=>{
      dispatch(CityByState(opt.value))
      callback(opt.value)
  }

  const onDrop = (pictureFiles) => {
    if(pictureFiles.target.files.length > 0){
        const imgPath =  URL.createObjectURL(pictureFiles.target.files[0])
        setFiles((prev)=>{
            return {
              ...prev,
              [pictureFiles.target.name]:pictureFiles.target.files
            }
        })
        setImagePath(imgPath)
        
    }
	};

  const getPinCodes = (cityId) => {
    const pincodes = initialData.CitiesList.find( (item) => item._id === cityId )?.areas
      const pinList = pincodes?.map( (item) => {
        return {
          value:item._id,
          label: `${item.pincode} (${item.name})`
        }
      }) || []
      return pinList
  }

  const onCityChange = (callback, opt)=>{
    setPinCodeList(getPinCodes(opt.value))
    callback(opt.value)
  }

  function onCancel(e){
    //const queryString  = new URLSearchParams(locationData.state).toString()
    navigate(`/users`);
    return;
  }

  function fetchParentUsers(callback, value) {
    callback(value)
      const { role: roleId, departments: departmentId} = getValues()
      if (departmentId && roleId) {
        dispatch(getParentUsers({roleId, departmentId}))
      }
  }

  function setAssignState(callBack, values) {
      const ids = values.map( (item) => item.value )
      console.log(ids)
      callBack(ids)
  }

  function onStatusChange(callBack, value) {
      const {
        empCode,
        name: fullName
      } = getValues();
      if ( value === 'inactive' && empCode) {
          setShowStatusPopup(true);
          const onSubmit = (selectedTeamMember) => {
            setShowStatusPopup(false);
            setValue('replaceById', selectedTeamMember)
          }
          const onClose = () => {
            setShowStatusPopup(false);
            setValue('replaceById', null)
          }
          const params = { 
              fullName, 
              onSubmit, 
              onClose,
              type: "staff", 
              userId: userData?._id, 
              teamList: replacementList 
          }
          setPopUpContent( <ReplaceUser params = {  {...params} }/>)   
      } else {
        setValue('replaceById', null)
      }
      callBack(value)
  }

  return (
    <React.Fragment>
      <div className="ecommarce-dashboard">
        <div className="row">
          <div className="col-md-6 col-lg-12">
            <div className="card payment-card">
              <div className="card-header">
                <h4 className="card-title">
                    Add User
                </h4>
              </div>
              <hr/>
              <div className="card-body">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <input 
                    {...register("replaceById")} 
                    type="hidden" 
                    disabled={ !getValues('replaceById') }
                    readOnly
                    autoComplete="false" className={`input-txt form-control`}
                  />
                  <div className="form-row">
                    <div className="form-group col-md-3">
                      <label htmlFor="empCode" className={`input-label ${errors?.empCode && "error"}`}>Employe Code</label>
                      <input 
                        {...register("empCode")} 
                        type="text" 
                        autoComplete="false" className={`input-txt form-control ${errors?.empCode && "error"}`}
                        placeholder="Emp Code" 
                      />
                      {errors.empCode && <FormError message={errors?.empCode?.message} />}
                    </div>
                    <div className="form-group col-md-3">
                      <label htmlFor="name" className={`input-label ${errors?.name && "error"}`}>Full Name</label>
                      <input 
                        {...register("name")} 
                        type="text" 
                        autoComplete="false" className={`input-txt form-control ${errors.name && "error"}`}
                        placeholder="Full Name" 
                      />
                      {errors.name && <FormError message={errors.name.message} />}
                    </div>
                    <div className="form-group col-md-3">
                      <label htmlFor="email"  className={`input-label ${errors.email && "error"}`}>Email</label>
                      <input 
                        {...register("email")}
                        type="text" 
                        autoComplete="false" className={`input-txt form-control ${errors.email && "error"}`}
                        placeholder="Email" 
                      />
                      {errors.email && <FormError message={errors.email.message} />}
                    </div>
                    <div className="form-group col-md-3">
                      <label htmlFor="phone" className="input-label">Mobile Number</label>
                      <input 
                        type="text" 
                        autoComplete="false" className={`input-label form-control ${errors.phone && "error"}`}
                        placeholder="Mobile Number" 
                        {...register("phone", { 
                          required:"Please enter mobile number", 
                          pattern: {
                            value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                            message: "Please enter a valid mobile number",
                          } 
                        })}
                      />
                      {errors.phone && <FormError message={errors.phone.message} />}
                    </div>
                    <div className="form-group col-md-3">
                        <label className={`d-block ${errors.gender && "error"}`}>
                          Gender
                        </label>
                        <Controller
                          control={control}
                          name="gender"
                          render={({ field: { value, onChange } }) => (
                            <SelectBox
                              options={defaultConfig.gender}
                              isClearable={true}
                              onChange={(opt) => onChange(opt?.value)}
                              value={defaultConfig.gender.find(
                                (option) => option.value === value
                              )}
                            />
                          )}
                        />
                        {errors.gender && (
                          <FormError message={errors.gender.message} />
                        )}
                    </div>
                    <div className="form-group col-md-3">
                      <label className={`d-block ${errors.state && "error"}`}>
                        State
                      </label>
                      <Controller
                        control={control}
                        name="state"
                        render={({ field: { value, onChange } }) => (
                          <SelectBox
                            options={states}
                            closeMenuOnSelect={false}
                            isClearable={true}
                            onChange={(opt) => onStateChange(onChange, opt)}
                            value={states.find(
                              (option) => option.value === value
                            )}
                          />
                        )}
                      />
                      {errors.state && (
                        <FormError message={errors.state.message} />
                      )}
                    </div>

                    <div className="form-group col-md-3">
                      <label className={`d-block ${errors.city && "error"}`}>
                        City
                      </label>
                      <Controller
                        control={control}
                        name="city"
                        render={({ field: { value, onChange } }) => (
                          <SelectBox
                            options={cities}
                            isClearable={true}
                            onChange={(opt) => onCityChange(onChange, opt)  }
                            value={cities.find(
                              (option) => option.value === value
                            )}
                          />
                        )}
                      />
                      {errors.city && (
                        <FormError message={errors.city.message} />
                      )}
                    </div>
                    
                    <div className="form-group col-md-3">
                      <label
                        className={`input-label ${errors.pincode && "error"}`}
                      >
                        Pincode
                      </label>
                      <Controller
                          control={control}
                          name="pincode"
                          render={({ field: { value, onChange } }) => (
                            <SelectBox
                              options={pinCodeList}
                              isClearable={true}
                              onChange={(opt) => onChange(opt?.value)}
                              value={pinCodeList.find(
                                (option) => option.value === value
                              )}
                            />
                          )}
                        />
                        {errors.gender && (
                          <FormError message={errors.gender.message} />
                        )}
                      {errors.pincode && (
                        <FormError message={errors.pincode.message} />
                      )}
                    </div>
                    
                    <div className="form-group col-md-3">
                        <label className={`d-block ${errors.role && "error"}`}>
                          Roles
                        </label>
                        <Controller
                          control={control}
                          name="role"
                          render={({ field: { value, onChange } }) => (
                            <SelectBox
                              options={roleList}
                              isClearable={true}
                              onChange={(opt) => fetchParentUsers(onChange, opt?.value) }
                              value={roleList?.find(
                                (option) => option.value === value
                              )}
                            />
                          )}
                        />
                        {errors.role && (
                          <FormError message={errors.role.message} />
                        )}
                    </div>
                    
                    <div className="form-group col-md-3">
                        <label className={`d-block ${errors.departments && "error"}`}>
                          Departments
                        </label>
                        <Controller
                          control={control}
                          name="departments"
                          render={({ field: { value, onChange } }) => (
                            <SelectBox
                              options={departmentsList}
                              isClearable={true}
                              onChange={(opt) => fetchParentUsers(onChange, opt?.value) }
                              value={departmentsList.find(
                                (option) => option.value === value
                              )}
                            />
                          )}
                        />
                        {errors.departments && (
                          <FormError message={errors.departments.message} />
                        )}
                    </div>
                    <div className="form-group col-md-3">
                        <label className={`d-block ${(errors.status || errors?.replaceById) && "error"}`}>
                          Status
                        </label>
                        <Controller
                          control={control}
                          name="status"
                          //value={defaultConfig.status[0]["value"]}
                          defaultValue={defaultConfig.status[0]["value"]}
                          render={({ field: { value, onChange } }) => (
                            <SelectBox
                              options={defaultConfig.status}
                              isClearable={true}
                              onChange={(opt) => onStatusChange(onChange, opt?.value) }
                              value={defaultConfig.status.find(
                                (option) => option.value === value
                              )}
                            />
                          )}
                        />
                        {(errors.status || errors?.replaceById) && (
                          <FormError message={errors?.status?.message || errors?.replaceById?.message} />
                        )}
                    </div>
                    
                    {
                      typeof params.id === "undefined"?
                      <>
                        <div className="form-group col-md-3">
                          <label htmlFor="password" className="input-label">Password</label>
                          <input 
                            type="password" 
                            {...register("password")}
                            autoComplete="false" className={`input-label form-control ${errors.password && "error"}`}
                            placeholder="*******" 
                          />
                          {/* {<a id="eye-icon">
                                                    <i className="far fa-eye" />
                                                </a>} */}
                          {errors.password && <FormError message={errors.password.message} />}
                        </div>
                        <div className="form-group col-md-3">
                          <label htmlFor="confPass" className="input-label">Confirm Password</label>
                          <input 
                            type="password" 
                            {...register("confPass")}
                            autoComplete="false" className={`input-label form-control ${errors.confPass && "error"}`} 
                            placeholder="*******" 
                          />
                          {/* {<a id="eye-icon">
                                                    <i className="far fa-eye" />
                                                </a>} */}
                          {errors.confPass && <FormError message={errors.confPass.message} />}
                        </div>
                      </>:''
                    }  

                    <div className="form-group col-md-3">
                        <label className={`d-block ${errors.reportingTo && "error"}`}>
                          Reporting To
                        </label>
                        <Controller
                          control={control}
                          name="reportingTo"
                          render={({ field: { value, onChange } }) => (
                            <SelectBox
                              options={ reportingTo }
                              isClearable={true}
                              onChange={(opt) => onChange(opt?.value)}
                              value={reportingTo?.find(
                                (option) => option.value === value
                              )}
                            />
                          )}
                        />
                        {errors.reportingTo && (
                          <FormError message={errors.reportingTo.message} />
                        )}
                    </div> 
                    <div className="form-group col-md-3">
                      <label className={`d-block ${errors.state && "error"}`}>
                        Assign State
                      </label>
                      <Controller
                        control={control}
                        name="assignState"
                        render={({ field: { value, onChange } }) => (
                          <SelectBox
                            options={states}
                            closeMenuOnSelect={false}
                            isMulti
                            isClearable={true}
                            onChange={(opt) => setAssignState(onChange, opt)}
                            value={states.filter(
                              (option) => value?.indexOf(option.value) >= 0 
                            )}
                          />
                        )}
                      />
                      {errors.state && (
                        <FormError message={errors.state.message} />
                      )}
                    </div>
                    <div className={"col-3"}>
                      <div className="form-group mb-3">
                        <label 
                            className={
                            errors?.address && "error"}>
                            Address
                        </label>
                        <textarea
                          {...register("address")}
                          type="text"
                          defaultValue=""
                          placeholder="Address "
                          className={`form-control ${
                            errors.address?.message && "error"
                          }`}
                        />
                        {errors?.address?.message && (
                            <FormError
                            message={
                              errors?.address?.message
                            }
                            />
                        )}
                      </div>
                    </div>

                    <div className="col-sm-12">
                        <ul>
                          <li className="text-dark"><b>*Image size should not be more than 200kb</b></li>
                          <li className="text-dark"><b>*Allow only .Jpeg and .Png image type </b></li>
                        </ul>
                      </div>
                      <div className="col-sm-2 pl-0 pr-0">
                          <div className="img-prev col-12 form-group">
                              <label
                                  htmlFor="image">
                                  Profile Image
                              </label>
                              <div className="ImgPreview">
                                <img src={imagePath} alt="" />
                              </div>
                              <div className="file btn btn-lg btn-primary fileUpload col-sm-9">
                                  Upload
                                  <input 
                                    type="file"  
                                    {...register("image")} 
                                    accept="image/png, image/jpeg"
                                    onChange={(event)=> onDrop(event)}
                                  />
                              </div>
                              <br/>
                              {errors.image && (
                                <FormError message={errors.image?.['message']} />
                              )}   
                          </div>
                      </div>

                  </div>
                  <hr/>
                  <div className="col-12 text-right">
                      <button disabled={loading} type="submit" className="btn-success text-right">Save</button>
                      &nbsp;
                      <button disabled={loading} onClick={onCancel} type="submit" className="btn-danger text-right">Cancel</button>                      
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading === true || loading?<Loading/>:"" }
      {success || vErrors? 
        <MessageModel
          btnEvent={ ()=>{
            dispatch(resetApiStatus()) 
            reset()
            if(success) 
              navigate(`/users`);
            }}
          success={success?true:false}
          message={success || vErrors}
        />
      :""}
      { showStatusPopup ?
        <ModelBox data={ {
          size: "md", 
          show: true, 
          title: 'Replace Team Member', 
          content: { ...popUpContent },
          onClose: () => {
            setShowStatusPopup(false);
          }
          
         
      } } /> : ''
      } 
    </React.Fragment>
  )

} 